import styled from "styled-components";

export const StyledExchangeUserPairsWrapper = styled.div`
  .exchange-user-pairs-head {
    padding: 20px 0 30px;
    display: grid;
    grid-template-columns: max-content 175px;
    grid-gap: 20px;

    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
    }
  }

  .apply-to-wrapper {
    margin: 0;
  }

  .exchange-user-pairs {
    &__head, &__row {
      grid-template-columns: repeat(8, minmax(0, 1fr)) minmax(0, 335px);
    }

    &__actions {
      display: grid;
      grid-template-columns: repeat(2, max-content);
      grid-gap: 25px;
      justify-content: end;
      
      button[disabled] {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
`;